








































































import CoButton from '../../Atoms/co-button/CoButton.vue';
import CoIcon from '../../Atoms/co-icon/CoIcon.vue';
import CoRoundButton from '../../Atoms/co-round-button/CoRoundButton.vue';
import CoText from '../../Atoms/co-text/CoText.vue';
import CoShare from '../../Organisms/co-share/CoShare.vue';
import CoCard from '../co-card/CoCard.vue';
import CoReactions from '../co-reactions/coReactions.vue';
import CoUser from '../co-user/CoUser.vue';

const VARIANTS = ['default', 'post', 'sidebar-card'];

export default {
    name: 'CoLockedContent',
    components: {
        CoButton,
        CoCard,
        CoIcon,
        CoReactions,
        CoRoundButton,
        CoShare,
        CoText,
        CoUser,
    },
    props: {
        variant: {
            type: String,
            default: 'default',
            validator(value) {
                return VARIANTS.includes(value);
            },
        },
        icon: {
            type: String,
            default: '',
        },
        title: {
            type: String,
            default: '',
        },
        user: {
            type: Object,
            default: () => ({}),
        },
        hideUnlockButton: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        previewSeed() {
            const seedSource = `${this.variant}-${this.user?.ID || this.user?.Slug || this.user?.Name || 'locked'}`;
            return seedSource.split('').reduce((sum, char) => sum + char.charCodeAt(0), 0);
        },
        previewCounts() {
            return {
                comments: this.seededCount(this.previewSeed + 31, 2, 12),
            };
        },
        previewTimestamp() {
            return Math.floor(Date.now() / 1000) - this.seededCount(this.previewSeed + 53, 600, 21600);
        },
    },
    methods: {
        seededCount(seed, min, max) {
            const normalizedSeed = Math.abs(Math.sin(seed) * 10000);
            return Math.floor(normalizedSeed % (max - min + 1)) + min;
        },
        emitUnlock(event) {
            this.$emit('unlock', event);
        },
    },
};
